import axios from "axios";
import { getUserTimezone } from "./timezone";

axios.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  config.headers["X-Timezone"] = getUserTimezone();
  return config;
});
